// Externals
import React, { useContext } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { getDynamicBffUrl } from '../../middleware/bffUrlMiddleware';

// Contants
import { withCurrency } from '../currency';
import { GeoIPContext } from '../geoip/GeoIPProvider';
// Selectors
import { selectSession } from '../../selectors/session';

// Components
import { LandingPage as LandingPageComponent } from '@homeexchange/landing-page';

const LandingPage = (props) => {
    const { currency, localeDescription, session } = props;
    const { geoipLocal } = useContext(GeoIPContext);

    const config = {
        apiUrl: getDynamicBffUrl(process.env.URL_BFF),
        assetsUrl: process.env.URL_MIGRATION_ASSETS,
        jawgToken: process.env.JAWG_KEY,
        jawgUrl: process.env.URL_JAWG_URL,
        locale: localeDescription,
        currency: currency,
        session,
        trustpilot: {
            businessUnitId: process.env.TRUSTPILOT_BUSINESS_UNIT_ID,
            apiKey: process.env.TRUSTPILOT_API_KEY
        },
        geoipLocal
    };

    // TODO: remove this once the a bff route is added to get the club data
    if (window.gtg?.clubData) {
        config.club = window.gtg.clubData;
    }

    return <LandingPageComponent config={config} />;
};

LandingPage.propTypes = {
    localeDescription: PropTypes.string,
    currency: PropTypes.string,
    session: PropTypes.object
};

const mapStateToProps = (state) => ({
    localeDescription: state.localeDescription,
    currency: state.currency,
    session: selectSession(state)
});

export default compose(connect(mapStateToProps), withCurrency)(LandingPage);
